import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId) {
        return request(api.visit.PLAN + "/" + keyId, METHOD.GET);
    },
    async saveFormDetail(result) {
        return request(api.visit.PLAN, METHOD.POST, result);
    },
    // async upDateFormDetail(result) {//保存或修改
    //     return request(api.visit.PLAN, METHOD.PUT, result);
    // },
    async getMenuList(keyId='') {
        return request(api.comm.DEPT + "?parentId=" + keyId, METHOD.GET, {"filter.eq.isUse":1});
    },
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async deleteItem(keyId) {//获取详情
        return request(api.visit.PLAN + "/" + keyId, METHOD.DELETE);
    },
    // async popSelect() {
    //     return request(api.comm.DEPT + '/popSelect', METHOD.GET);
    // },
    async popSelect() {
        return request(api.visit.DEPT + '/popSelect', METHOD.GET);
    },
    async popSelectVisit() {
        return request(api.visit.PLAN + '/popSelectVisit', METHOD.GET);
    },
    async getImport() {
        return request(api.visit.PLAN + '/import', METHOD.POST);
    },


}

export const bigDataApi = {
    async popSelectVisit() {
        return request(api.visit.PLAN + '/popSelectVisit', METHOD.GET);
    },
}

export default {dataApi, bigDataApi}
